module.exports = __webpack_public_path__ + "img/9788957983287.7d7cfc29.jpg";